import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Brand from './Brand';
import { categories } from '../data/news';

const { FiMenu, FiSearch, FiX, FiMail } = FiIcons;

function Header() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="utility-bar">
        <div className="shell utility-inner">
          <span>Monday, May 18, 2026</span>
          <span>Colombo · 29°C</span>
          <Link to="/about">
            Independent journalism for an informed public
          </Link>
        </div>
      </div>

      <header className="site-header">
        <div className="shell header-main">
          <button
            className="icon-button menu-button"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            <SafeIcon icon={open ? FiX : FiMenu} />
          </button>
          <Brand />
          <div className="header-actions">
            <Link
              className="icon-button"
              to="/search"
              aria-label="Search"
            >
              <SafeIcon icon={FiSearch} />
            </Link>
            <a className="subscribe-button" href="#newsletter">
              <SafeIcon icon={FiMail} /> Subscribe
            </a>
          </div>
        </div>

        <nav className={`primary-nav ${open ? 'is-open' : ''}`}>
          <div className="shell nav-inner">
            <NavLink to="/" end onClick={() => setOpen(false)}>
              Home
            </NavLink>
            {categories.map((category) => (
              <NavLink
                key={category}
                to={`/${category.toLowerCase().replaceAll(' ', '-')}`}
                onClick={() => setOpen(false)}
              >
                {category}
              </NavLink>
            ))}
          </div>
        </nav>

        <div className="ticker">
          <div className="shell ticker-inner">
            <b><span /> TRENDING</b>
            <div className="ticker-copy">
              <Link to="/article/island-economy-enters-a-new-phase-of-growth">
                New indicators point to improving economic confidence
              </Link>
              <Link to="/article/responsible-ai-enters-mainstream">
                Responsible AI enters the product mainstream
              </Link>
              <Link to="/article/national-side-prepares-for-series">
                National side prepares for defining home series
              </Link>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;